import { z } from 'zod'

import { NormalizedNumber } from '../types/NormalizedNumber.js'

export const normalizedNumberSchema = z.string().transform((value, ctx) => {
  try {
    return NormalizedNumber(value)
  } catch {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: `Invalid normalized number: ${value}`,
    })
    return z.NEVER
  }
})
